// i18n area 'storage' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.cs-CZ.meta.json.
import type { enUS } from './storage'

export const csCZ: typeof enUS = {
  storage: {
    pools: {
      title: 'Úložiště',
      createTitle: 'Vytvořit úložiště',
      path: 'Cesta',
      pathHint: 'Absolutní cesta pod povoleným rootem (default /var/lib/tvirt/pools/)',
      shared: 'Sdílené úložiště',
      sharedChip: 'sdílené',
      sharedVerifiedChip: 'sdílené · ověřeno',
      sharedVerifiedTooltip: 'Sdílení ověřeno: křížové sondy potvrzují, že každý člen vidí data zapsaná ostatními.',
      sharedDisputedChip: 'sdílené · NEOVĚŘENO',
      sharedDisputedTooltip: 'Sdílení NEOVĚŘENO',
      sharedDisputedPair: '{observer} nevidí data, která zapsal {writer}',
      sharedHint: 'Síťová share namountovaná lokálně na stejné cestě na každém členu — předpoklad migrace za běhu (deklarativní).',
      sharedDanger: 'NEBEZPEČÍ — TVirt tomuto příznaku VĚŘÍ: když ho zapnete, každý člen předpokládá, že na této cestě vidí TYTÉŽ bajty. Na složce, která NENÍ skutečně sdílený mount (NFS/CIFS/klastrový filesystem), je výsledkem poškození a ztráta dat při první migraci nebo prvním restartu HA na jiném uzlu. Zapněte ho, jen pokud je cesta share namountovaná identicky na každém uzlu.',
      type: 'Typ',
      capacity: 'Kapacita',
      provisioned: 'Alokováno',
      provisionedOvercommit: 'Potenciální závazek nad kapacitu: thin svazky mohou narůst až na {n} GiB.',
      phase: { ready: 'Připraveno', degraded: 'Degradováno', error: 'Chyba' },

      // Round #156 (standard dialogů): KOMPLETNÍ dialog podrobností — karty,
      // řádky konfigurace per-driver a pozorovaný povrch.
      tabConfig: 'Konfigurace',
      tabCapacity: 'Kapacita a stav',
      cardIdentity: 'Identita',
      cardPlacement: 'Umístění',
      cardConnection: 'Připojení',
      usedReal: 'Skutečné využití',
      capacityUnknown: 'Uzel kapacitu tohoto poolu ještě nenahlásil — čísla se tu nevymýšlejí',
      overcommitHint: 'Alokováno nad kapacitu: na thin poolech legitimní, hlídejte skutečné využití',
      supportedContent: 'Podporovaný obsah',
      content: {
        disks: 'Disky',
        catalogFiles: 'Soubory katalogu',
        backups: 'Zálohy',
        appVolumes: 'Svazky App'
      },
      defaultDiskFormat: 'Výchozí formát disku',
      reserveGiB: 'Rezervované volné místo (GiB)',
      available: 'Dostupné',
      diskCount: 'Disky',
      filesystem: 'Filesystem',
      observedAt: 'Pozorováno',
      lostAtRow: 'Prohlášeno za ztracené',
      sharedProbeRow: 'Ověření sdílení',
      sharedProbeNodes: 'Sondované uzly',
      reachableFrom: 'Deklarovaná dosažitelnost',
      reachableFromHint: 'Uzly, ze kterých musí být toto úložiště dosažitelné. VM, jejíž disky, ISO nebo metadata žijí zde, se nespustí ani nezmigruje na uzel mimo tento seznam. Všichni členové jsou předvybráni — zužte podle libosti. Uzel, který do klastru vstoupí později, zůstává mimo, dokud ho sem nepřidáte.',
      reachableFromNone: 'nedeklarována',
      reachableFromTags: 'Dosažitelnost podle tagů',
      reachableFromTagsHint: 'Selektor tag=hodnota (položky oddělené čárkou, v AND): každý člen nesoucí tyto tagy je deklarován jako dosažitelný — dynamicky: otagování uzlu ho přivede dovnitř.',
      reachableFromTagsInvalid: 'Neplatný formát — použijte tag=hodnota, oddělené čárkou',
      reachableResolved: 'Výsledné uzly: {nodes}',
      reachableDeclaredNotSeen: 'deklarováno, ale nespatřeno sondou sdílení na: {nodes}',
      reachableSeenNotDeclared: 'spatřeno, ale nedeklarováno (mimo perimetr) na: {nodes}',
      cephCluster: 'Spravovaný klastr Ceph',
      appGuardTitle: 'Úložiště používané App',
      appEphemeralGuard: 'toto úložiště je klastrový efemérní pool App — nejdřív ho změňte na stránce App, pak ho odstraňte.',
      appInUseGuard: 'žijí zde rooty/svazky app: {apps} — nejdřív je přesuňte nebo odstraňte.',
      releaseRequiredTitle: "Odstranit '{name}' a uvolnit jeho obrazy?",
      releaseRequiredBatchTitle: 'Odstranit vybrané storage a uvolnit jejich obrazy?',
      releaseRequiredBody: 'Uvolnění obrazů nesmaže ANI JEDEN bajt: zrušení registrace nechá namespace na disku, obrazy prostě přestanou být materializované a každý odkaz scopů přežije jako claim — po opětovné registraci poolu jsou znovu adoptovány.',
      releaseConfirm: 'Odstranit a uvolnit obrazy'
    },
    lost: {
      chip: 'Ztraceno',
      action: 'Prohlásit za ztracené',
      confirmTitle: 'Prohlásit úložiště za ztracené',
      confirmBody: 'Prohlášení operátora na vlastní deklarované riziko: každá úloha ve frontě nebo běžící nad tímto úložištěm či jeho objekty SELŽE, mazání se stane jen záznamovým (žádná práce na filesystemu) a nová fyzická práce se odmítá. Bajtů se nikdy nikdo nedotkne — pokud se podklad vrátí k životu, zaregistrujte ho znovu a spusťte scan, který vše znovu adoptuje.',
      confirmSubmit: 'Prohlásit za ztracené',
      error: 'Prohlášení bylo odmítnuto'
    },
    findings: {
      action: 'Nalezené objekty',
      title: 'Nalezené objekty',
      empty: 'V namespace úložiště nebylo nic nalezeno',
      loadError: 'Nalezené objekty se nepodařilo načíst',
      actionError: 'Rozhodnutí bylo odmítnuto',
      colKind: 'Typ',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Tento adresář už byl inicializován jiným úložištěm: identitní pečeť byla přepsána pečetí tohoto úložiště. Obsah NEBYL dotčen — projděte nalezené objekty níže, naimportujte ty, které potřebujete, a pak toto upozornění zavřete.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Soubor katalogu',
        vmMetadata: 'Metadata VM',
        namespace: 'Namespace',
        foreign: 'Cizí',
        volumeGroup: 'Skupina svazků'
      },
      vgAdopt: {
        action: 'Adoptovat skupinu svazků',
        title: 'Adoptovat skupinu svazků',
        intro:
          'Toto zařízení již nese skupinu svazků s názvem TVirt, ale její pečeť nejmenuje žádné zde registrované storage. Může to být to, co na LUN zanechalo předchozí storage TOHOTO clusteru — nebo to, co zanechal JINÝ cluster TVirt na LUN, která změnila majitele: odsud vypadají oba případy stejně, a proto nikdo nerozhoduje za vás.',
        irreversible: 'Podívejte se na zařízení, pečeť a název, než budete pokračovat: adopci nelze vzít zpět.',
        device: 'Zařízení',
        seal: 'Pečeť',
        sealNone: 'žádná (bez tagu tvirt.storageId)',
        renameTo: 'Bude přejmenována na',
        renameNone: 'Bez přejmenování: název už je ten, který toto storage odvozuje',
        volumesNote:
          'Obsažené svazky se tímto gestem NEadoptují: další sken je nabídne jeden po druhém, jako běžné nalezené objekty.'
      },
      conflictChip: 'ID už existuje',
      dismissedChip: 'Ignorováno',
      adopt: 'Adoptovat',
      adoptFileTitle: 'Importovat do katalogu',
      adoptFileHint: 'Soubory existují jen uvnitř katalogů: vyberte cílový katalog pro nalezený soubor.',
      purge: 'Odstranit z disku',
      dismiss: 'Ignorovat',
      purgeConfirmTitle: 'Odstranit z disku',
      purgeConfirmBody: 'Nalezené bajty {id} budou z úložiště odstraněny. Tuto operaci nelze vrátit.',
      taskStarted: 'Spuštěno — pokračuje jako úloha na pozadí',
      scan: 'Skenovat úložiště',
      scanStarted: 'Sken zahájen…',
      scanDone: 'Sken dokončen — nalezené objekty jsou aktuální'
    },
    reinit: {
      action: 'Zopakovat inicializaci'
    },
    wizard: {
      addButton: 'Přidat',
      title: 'Přidat úložiště',
      back: 'Zpět',
      continue: 'Pokračovat',
      selectHint: 'Vyberte protokol a uvidíte, jak ho TVirt používá.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Exportovaná cesta',
      share: 'Share',
      username: 'Uživatelské jméno',
      password: 'Heslo',
      passwordHint: 'Jen pro zápis: uloženo pro mount, už se nikdy nezobrazí.',
      credential: 'Přihlašovací údaj',
      credentialManual: 'Zadat ručně',
      credentialHint: 'Položka keystore typu uživatelské jméno a heslo — alternativa k jejich zadání zde.',
      credentialEmpty: 'V keystore není žádný přihlašovací údaj typu uživatelské jméno a heslo — vytvořte ho v Systém → Přihlašovací údaje, nebo účet zadejte přímo níže.',
      options: 'Možnosti mountu',
      optionsHint: 'Oddělené čárkou, předané mount -o tak, jak jsou.',
      portal: 'Portál',
      portalHint: 'host[:port] — výchozí port je 3260.',
      target: 'Target IQN',
      targetHint: 'Název iSCSI targetu, začíná na iqn.',
      lun: 'LUN',
      wholeLunRow: 'Na discích: tento storage jmenuje jen target',
      wholeLunHint: 'Tento storage jmenuje jen target: jeho LUNy se stávají disky jeden po druhém (Vytvořit disk → převzít celý LUN), na target se nic nezapisuje.',
      lunHint: 'Číslo LUN na targetu — v pochybnostech 0.',
      chapCredential: 'Přihlašovací údaj (CHAP)',
      chapCredentialHint: 'Položka keystore typu CHAP (iSCSI) použitá při loginu — tajemství nikdy necestuje s úložištěm.',
      chapNone: 'Bez autentizace',
      chapEmpty: 'V keystore není žádný přihlašovací údaj typu CHAP (iSCSI) — vytvořte ho v Systém → Přihlašovací údaje. Bez něj zůstává login neautentizovaný.',
      address: 'Adresa',
      addressHint: 'Hostitel nebo IP targetu NVMe/TCP (traddr).',
      port: 'Port',
      portHint: 'TCP port targetu — 4420, pokud zůstane prázdné.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN subsystému na targetu, začíná na nqn.',
      nsid: 'NSID',
      nsidHint: 'ID namespace uvnitř subsystému — v pochybnostech 1.',
      dhchapCredential: 'Přihlašovací údaj (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Položka keystore typu DH-HMAC-CHAP (NVMe) použitá při připojení — tajemství nikdy necestuje s úložištěm.',
      dhchapNone: 'Bez autentizace',
      dhchapEmpty: 'V keystore není žádný přihlašovací údaj typu DH-HMAC-CHAP (NVMe) — vytvořte ho v Systém → Přihlašovací údaje. Bez něj zůstává připojení neautentizované.',
      monitors: 'Monitory',
      monitorsHint: 'Endpointy monitorů Ceph, host[:port], oddělené čárkou nebo novým řádkem — výchozí port 6789.',
      pool: 'Pool',
      poolHint: 'RBD pool ke konzumaci — jeden RBD obraz na disk.',
      fs: 'Filesystem',
      fsHint: 'Název filesystemu CephFS (mds_namespace při mountu).',
      fsPath: 'Cesta uvnitř filesystemu',
      fsPathHint: 'Absolutní cesta uvnitř filesystemu, kterou úložiště mountuje — v pochybnostech /.',
      cephxCredential: 'Přihlašovací údaj (cephx)',
      cephxCredentialHint: 'Položka keystore typu cephx: uživatelské jméno = jméno klienta (client.…), secret = klíč v base64. Povinná.',
      cephxNone: 'V keystore není žádný přihlašovací údaj cephx — vytvořte ho (typ: cephx) v Systém → Přihlašovací údaje, nebo ho nechte vyrazit spravovaný klastr Ceph přes "Navrhnout jako úložiště".',
      sharedByNature: 'Síťová úložiště jsou sdílená ze své podstaty: každý člen je mountuje na stejné cestě spravované TVirt.',
      error: 'Úložiště bylo odmítnuto',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Jiné',
        legacy: 'Legacy'
      },
      legacyHint: 'Stále plně podporované — jen bychom je nevybrali pro novou instalaci.',
      proto: {
        // Řádek `usage` (Luca 2026-07-24) říká, jak TVirt protokol používá —
        // především povolený obsah: dir/nfs/cifs hostí disky I obrazy ISO/disku
        // a šablony, blokové drivery (iscsi/nvme-tcp/rbd) JEN disky.
        dir: {
          name: 'Místní složka',
          desc: 'Adresář na uzlu: jednoduché a rychlé. Je LOKÁLNÍ pro jeden uzel, pokud cesta není skutečně sdílený mount — označit ji jako sdílenou, když není, stojí data.',
          usage: 'TVirt v ní uchovává disky VM, obrazy ISO/disku a šablony.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS export namountovaný klastrem — sdílený ze své podstaty.',
          usage: 'Hostí disky VM, obrazy ISO/disku a šablony.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Share Windows/Samba namountovaná klastrem — sdílená ze své podstaty.',
          usage: 'Hostí disky VM, obrazy ISO/disku a šablony.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Vzdálený filesystem přes SSH — bez potřeby NAS exportu.',
          usage: 'Na roadmapě.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokové LUN přes IP se sdíleným LVM navrchu.',
          usage: 'Jen disky — jeden thin svazek na disk; nehostí obrazy ISO ani šablony.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Distribuovaná bloková zařízení na klastru Ceph.',
          usage: 'Jen disky — jeden RBD obraz na disk, otevíraný nativně QEMU; nehostí obrazy ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Distribuovaný filesystem Ceph, mountovaný kernelem na klastru — shared by nature.',
          usage: 'Hostí disky VM, obrazy ISO/disku a šablony — rodina dir na filesystemu Ceph (přihlašovací údaj cephx povinný).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN přes FibreChannel fabric — klasická FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Totéž SCSI přes FibreChannel, s FC rámci zapouzdřenými v Ethernetu.' },

        // Živé od roundu #132 — klíčem je jméno driveru z contractu, takže
        // chip v seznamu úložišť rozřeší tutéž položku.
        'iscsi-lun': {
          name: 'iSCSI (celé LUNy)',
          desc: 'iSCSI target jako nosič celých LUNů: každý disk JE LUN, předaný hostovi syrový — bez LVM mezi tím.',
          usage: 'Jen disky — jeden celý LUN na disk, převzatý tak, jak je; SAN domov disků se sdíleným zápisem.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (celé namespace)',
          desc: 'NVMe subsystém jako nosič celých namespace: každý disk JE namespace, předaný hostovi syrový.',
          usage: 'Jen disky — jeden celý namespace na disk, převzatý tak, jak je; sdílený zápis ano, SCSI persistent reservations ne.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Vzdálené NVMe — žádné SCSI na cestě — přes obyčejné TCP, se sdíleným LVM navrchu.',
          usage: 'Jen disky — jeden thin svazek na disk; nehostí obrazy ISO ani šablony.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Vzdálené NVMe přes FibreChannel fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe přes FibreChannel fabric, který FCoE přenáší uvnitř Ethernetu — vrstvy FCoE a NVMe/FC naskládané na sobě.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI s datovou cestou přesunutou na RDMA — libovolný fabric (InfiniBand, iWARP, RoCE). Překonáno NVMe/RDMA, stále přítomné v diskových polích a v ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Nativní SCSI přes RDMA, éra před iSER: InfiniBand (s fabric discovery) a RoCE — přežívá v letitých HPC úložištích.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Vzdálené NVMe přes libovolný RDMA fabric — InfiniBand, iWARP, RoCE v1 i v2: jediná konfigurace, který z nich má, hlásí sám uzel.' },
        s3: { name: 'S3', desc: 'Objektové úložiště kompatibilní s S3 — obrazy a zálohy.' }
      }
    },
    catalogs: {
      title: 'Katalogy',
      createTitle: 'Vytvořit katalog',
      editTitle: 'Upravit katalog',
      docTitle: 'Katalog',
      notFound: 'Tento katalog (už?) neexistuje',
      scopeHint: 'Kdo čte tento scope, vidí (a může používat) každý soubor katalogu',
      files: 'Soubory',
      noFiles: 'Žádné soubory',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Systémový katalog (round #126): domov vestavěných objektů platformy —
      // čitelný pro všechny, zapisovatelný pro nikoho.
      systemChip: 'systémový',
      systemTooltip: 'Systémový katalog: hostí vestavěné objekty platformy a nelze ho měnit'
    },

    // Soubory katalogu (round K1, inventory v2e/v2g): katalog je domovem
    // souborových artefaktů klastru — jeden seznam, titulky podle kind.
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Typ',
      physicalSize: 'Fyzická velikost',
      virtualSize: 'Virtuální velikost',

      // Round K3 (#64) + K4 (#65, ova/ovf přes mapování boot-survival):
      // materializuje soubor vm-template jako VM Template inventáře.
      importTemplateAction: 'Importovat jako VM Template',
      importTemplateLegacy: 'Žádný deklarovaný formát — použitelné jako seed pro disky, nikoli k importu',
      importTemplateTitle: 'Importovat jako VM Template',
      importTemplateSubmit: 'Importovat',
      importTemplateError: 'Import se nezdařil',
      importTemplateHint: 'Balíček .tvtpl se stane VM Template: zmrazený hardware z manifestu plus jeden disk na entry archivu, každý ověřený proti svému checksumu. NIC a média CD/DVD nejsou součástí archivu — přidejte je po importu.',
      importTemplateQcow2Hint: 'Holý qcow2 se stane šablonou s JEDNÍM diskem a deklarovaným výchozím hardwarem: profil linux, UEFI, 2 vCPU, 2048 MiB, spouštění z jediného disku. Upravte při nasazení.',
      importTemplateName: 'Název šablony',
      importTemplateNameHint: 'Prázdné = {name} (-import-<n>, když je obsazeno)',
      importTemplateStorage: 'Úložiště pro disky',
      importTemplateMetadataStorage: 'Úložiště metadat',
      importTemplateMetadataHint: 'Blokové úložiště nehostí metadata VM (firmware, varstore) — vyberte nějaké dir/nfs/cifs.',
      importTemplateStarted: 'Import zahájen — šablona se objeví na kartě Šablony po dokončení úlohy.',

      // Mluvící popisky v jednotném čísle (#86): nálezy a sčítání říkají, CO
      // soubor je — obecný "Soubor katalogu" zůstává jen jako fallback.
      kind: {
        iso: 'Obraz ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Šablona VM',
        'oci-image': 'Obraz OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Obrazy ISO',
        'ct-rootfs': 'Šablony CT',
        'vm-template': 'Šablony VM',
        'oci-image': 'Obrazy OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Přidat obraz ISO',
        'ct-rootfs': 'Registrovat šablonu CT',
        'vm-template': 'Přidat šablonu VM',
        'oci-image': 'Přidat obraz OCI',
        'firmware-ovmf': 'Přidat firmware OVMF'
      },
      formatHint: 'Odvozeno z přípony zvoleného souboru — opravte, pokud hádal špatně',
      tarballHint: 'Rootfs tarball ve standardním formátu LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, nebo prostý .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar nebo .tar.gz), např. z docker save',
      uploadResumeHint: 'Upload přerušen — soubor čeká na upload: odešlete znovu se stejným souborem a pokračujte',
      moveTitle: 'Přesunout soubor',
      moveHint: 'Dva nezávislé rozměry: Katalog přesune odkaz (stejné id, žádný bajt se nepohne, scope se stane scopem cílového katalogu); Úložiště přesune data — každá propojená kopie ho následuje, odmítnuto, dokud se soubor používá. Zvoleny společně: nejdřív katalog, pak úložiště.',
      moveCatalog: 'Cílový katalog',
      moveCatalogHint: 'Domov mění jen odkaz: VM, které má soubor připojený, musí cílový katalog vidět',
      keepCurrent: 'Neměnit',
      rehomed: 'Odkaz přesunut do zvoleného katalogu',
      copyAction: 'Kopírovat do katalogu…',
      copyTitle: 'Kopírovat do katalogu',
      copyLinkHint: 'Kopie je nový odkaz na tatáž data — na úložišti se nic neduplikuje.',
      copyCatalog: 'Cílový katalog',
      copyCatalogHint: 'Kopírování je způsob, jak soubor cestuje mezi katalogy',
      sameCatalog: 'Stejný jako zdroj',
      sharedObjectHint: 'Data tohoto souboru jsou sdílena propojenými kopiemi ({count})',
      deleteLastLink: 'Toto je POSLEDNÍ odkaz na tento obsah: z úložiště budou odstraněna i data.',
      deleteLinkOnly: 'Odebere se jen tento odkaz — data zůstávají, stále dosažitelná přes ostatní propojené kopie ({count}).',
      noCatalog: 'Zatím žádný katalog není — vytvořte nějaký',
      inlineCatalogName: 'Název katalogu',

      // Soubory vestavěné v platformě (round #126): storage null — čtou se
      // a klonují, nikdy move/delete/rename.
      embeddedChip: 'vestavěný',
      embeddedStorage: 'Vestavěno v platformě',
      embeddedNoMove: 'Vestavěný soubor platformy: nežije na žádném úložišti — místo toho ho naklonujte',
      embeddedCopyHint: 'Klon materializuje vestavěné bajty na skutečné úložiště: vyberte cílové úložiště a katalog — kopie je obyčejný soubor',
      sourceEmbedded: 'Vestavěno v platformě',
      nodesRow: 'Přítomnost na uzlech',
      nodesSummary: '{present} z {total} uzlů ji má',
      nodePresent: 'přítomen',
      nodeMissing: 'chybí',
      nodeUnknown: 'zatím nenahlášeno',
      nodesHint: 'Asset leží na disku každého uzlu (balíček trantor-tvirt-assets): uzel, který ho nemá, nemůže definovat VM s tímto firmwarem ani poskytovat Guest Tools. Různé verze mezi uzly jsou během postupné aktualizace normální.',

      // Download (round #108): bajty cestují s vlastním vyhrazeným oprávněním.
      downloadAction: 'Stáhnout',
      downloadNotReady: 'Obsah ještě není připraven — download vyžaduje soubor ve stavu ready',
      downloadDenied: 'Vaše role nezahrnuje catalog.download — stažení bajtů je oprávnění oddělené od používání souboru',

      // Round #156 (standard dialogů): chybějící řádky pro čtení v dialogu
      // podrobností — fakta sdíleného objektu, deklarovaný checksum,
      // uživatelé souboru.
      objectRow: 'Objekt úložiště',
      objectLinksRow: 'Propojené kopie',
      declaredChecksum: 'Deklarovaný SHA-256',
      usedByRow: 'Používají',
      usedByVms: 'VM',
      usedByDisks: 'Disky',
      transferRow: 'Přenos',
      storageLockHint: 'Mění se jen akcí Přesunout'
    },

    // Sčítání per-storage (round K1, inventory v2b #2): jen pro čtení,
    // každý objekt se spravuje ze své sekce.
    objects: {
      action: 'Prozkoumat obsah',
      title: 'Obsah úložiště',
      hint: 'Sčítání toho, co žije na tomto úložišti, jen pro čtení — každý objekt se spravuje ze své sekce.',
      empty: 'Na tomto úložišti není nic registrováno',
      loadError: 'Obsah se nepodařilo načíst',
      colDetail: 'Podrobnost',
      manage: 'Spravovat v jeho sekci',
      kind: {
        disk: 'Disk',
        catalogFile: 'Soubor katalogu',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadata VM',
        appRoot: 'Root App',
        appVolume: 'Svazek App'
      }
    },
    inventory: {
      tabCatalogs: 'Katalogy',
      storage: 'Úložiště',
      sizeGib: 'Velikost (GiB)',
      format: 'Formát',
      size: 'Velikost',
      sourceType: 'Zdroj',
      sourceFile: 'Nahrání souboru',
      sourceUrl: 'Stažení z URL',
      file: 'Soubor',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Povinné: stažení se ověřuje proti tomuto SHA-256',
      verifyChecksum: 'Ověřit checksum',
      checksumOffHint: 'Stažení bude přijato bez ověření — spočtený SHA-256 se přesto zaznamená',
      uploading: 'Nahrávání…',
      move: {
        action: 'Přesunout',
        diskTitle: 'Přesunout disk',
        target: 'Cílové úložiště',
        diskHint: 'Disk si zachová identitu: bajty putují do zvoleného úložiště. VM, která ho používá, musí být vypnutá; s přítomnými snímky iSCSI strana přesun odmítne.',
        noTargets: 'Žádné kompatibilní cílové úložiště',
        submit: 'Přesunout',
        error: 'Přesun byl odmítnut'
      },
      clone: {
        action: 'Klonovat',
        title: 'Klonovat disk',
        name: 'Název kopie',
        storage: 'Cílové úložiště',
        sameStorage: 'Stejné jako zdroj',
        linked: 'Linked clone',
        linkedHint: 'Okamžitý qcow2 overlay zřetězený se zdrojovým diskem (jen zdroje qcow2). Výchozí je úplná kopie.',
        linkedCrossHint: 'Linked clone musí zůstat na úložišti zdroje: zvolte "Stejné jako zdroj", abyste ho povolili.',
        submit: 'Klonovat',
        error: 'Klonování bylo odmítnuto'
      },
      copy: {
        action: 'Kopírovat',
        name: 'Název kopie',
        storage: 'Cílové úložiště',
        sameStorage: 'Stejné jako zdroj',
        submit: 'Kopírovat',
        error: 'Kopie byla odmítnuta'
      },
      taskStarted: 'Spuštěno — pokračuje jako úloha na pozadí',
      cephObjects: 'Přejít na podrobnosti objektu v Ceph',
      phase: {
        ready: 'Připraveno',
        creating: 'Vytváří se',
        'awaiting-upload': 'Čeká na upload',
        downloading: 'Stahuje se',
        verifying: 'Ověřuje se',
        deleting: 'Odstraňuje se',
        error: 'Chyba',
        'in-use': 'Používá se'
      }
    }
  }
}
